import { render, staticRenderFns } from "./DynamicDetails.vue?vue&type=template&id=403bcb46&scoped=true&"
import script from "./DynamicDetails.vue?vue&type=script&lang=js&"
export * from "./DynamicDetails.vue?vue&type=script&lang=js&"
import style0 from "./DynamicDetails.vue?vue&type=style&index=0&id=403bcb46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403bcb46",
  null
  
)

export default component.exports